import type { GorkemState } from '../types';

const transitions: Record<GorkemState, GorkemState[]> = {
  INACTIVE: ['ENTERING'],
  ENTERING: ['WALKING_TO_TABLE'],
  WALKING_TO_TABLE: ['SITTING'],
  SITTING: ['WAITING_FOR_ORDER'],
  WAITING_FOR_ORDER: ['WAITING_FOR_FOOD'],
  WAITING_FOR_FOOD: ['GIFTING'],
  GIFTING: ['WAVING'],
  WAVING: ['LEAVING'],
  LEAVING: ['COMPLETE'],
  COMPLETE: [],
};

export class GorkemStateMachine {
  private current: GorkemState = 'INACTIVE';

  get state(): GorkemState {
    return this.current;
  }

  transition(next: GorkemState): void {
    if (!transitions[this.current].includes(next)) throw new Error(`Invalid Görkem transition: ${this.current} -> ${next}`);
    this.current = next;
  }
}
